import * as Sentry from '@sentry/react';
import { USER_ROLE } from '../../helpers/user/authorization';
import { version } from '../../../package.json';

const sentryConf = {
  init: () =>
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      release: 'frontend-france-challenges@' + version,
      environment: process.env.REACT_APP_ENABLE_SENTRY
    }),
  scope: () =>
    Sentry.configureScope(function(scope) {
      scope.setUser({
        id: localStorage.getItem('id'),
        username: localStorage.getItem('username'),
        token: localStorage.getItem('token') ? 'Oui' : 'Aucun Token',
        role: USER_ROLE
      });
    })
};

export const initSentry = () => {
  if (!process.env.REACT_APP_ENABLE_SENTRY) {
    console.log('SENTRY DISABLED');
    return null;
  } else {
    sentryConf.init();
    sentryConf.scope();
  }
};
